module.exports = __webpack_public_path__ + "static/media/icon-communication.adc35111.svg";